import React, { Component } from 'react';
import TextFieldGroup from '../common/TextFieldGroup';
import classnames from 'classnames';
import './UserCreate.css';
import CheckboxListComponent from '../common/CheckboxListComponent';
import { connect } from 'react-redux';
import Groups from '../../ducks/Groups';
import { bindActionCreators } from 'redux';
import { validateInput } from '../../validations/userCreate';
import toastr from 'toastr';
import Users from '../../ducks/Users';
import * as _ from 'lodash';
import { WhiteSpinner, Spinner } from '../common/Spinner/index';
import SelectComponent from '../select';

class UserCreate extends Component {
   toasterMsgs = [
    {"success" : toastr.success},
    {"error": toastr.error}
  ]

  constructor(props) {
    const groupData = JSON.parse(localStorage.getItem('groupInfo'))
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      userName: '',
      email: '',
      phone: '',
      type: 'Manager',
      activeTab: 'roles',
      errors: {},
      // selectedGroup: groupData.depthLevel !== 6 ? [] : [{value: this.props.match.params.id}],
      selectedGroup: [{value: this.props.match.params.id}],
      roleList: [],
      role: '',
      // groupDepthLevel: groupData.depthLevel,
      loader: false,
      companyInfo: JSON.parse(localStorage.getItem('companyInfo')),
      isLoading: true
    }
  }

  async componentDidMount() {
   
    

    // if (!(this.props.groupList && this.props.groupList.length))
      await this.props.dispatch(Groups.creators.getSubGroups(this.state.companyInfo.groupId));

    this.setState({
      ...this.state,
      isLoading: false
    });
  }

  isValid = () => {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }

    return isValid;
  };
  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
      errors: {
        ...this.state.errors,
        [e.target.name]: ''
      }
    });
  };
  isTabActive = name => {
    return name === this.state.activeTab;
  };
  handleTabClick = name => {
    // this.setState({activeTab: name})
  };


  onSubmit = async e => {
    e.preventDefault();
      try {
        const userInfo = {
          firstName: _.trim(this.state.firstName),
          lastName: _.trim(this.state.lastName),
          email: _.trim(this.state.email),
          phone: _.replace(this.state.phone, '+92', '0'),
          groupId: this.state.selectedGroup[0].value
        };

        if (userInfo.phone.slice(0, 2) === '92') {
          userInfo.phone = userInfo.phone.replace('92', '0')
        };
        if (userInfo.phone.length > 11) {
          return toastr.error('Invalid phone number');
        }
        this.setState({
          ...this.state,
          loader: true
        })
        const userResponse = await this
          .props
          .actions
          .createUser(userInfo);
          if (userResponse.code === 'success') {
            toastr.success(userResponse.message);
          } else if (userResponse.code === 'error') {
            toastr.error(userResponse.message);
          }
        // toastr.userResponse.code(userResponse.message);
        this.setState({
          ...this.state,
          loader: false
        })
        this
          .props
          .history
          .push('/users');
      } catch (e) {
        this.setState({
          ...this.state,
          loader: false
        })
        toastr.error(e.response ? e.response.data.message : e);
      }
  };

  handleGroupChange = (selectedOption) => {
    this.setState({
      ...this.state,
      selectedGroup: selectedOption
    });
  }

  render() {
    const {
      firstName,
      lastName,
      userName,
      email,
      phone
    } = this.state;
    const loader = <WhiteSpinner key='1'/>
    const loaderRoles = <Spinner key='1'/>;

    return (
      <>
      {this.state.isLoading ? [loaderRoles] :
      <div>
        <div className='heading-container'>
          <h3 className='font-weight-bold'>New User</h3>
        </div>
        <form onSubmit={this.onSubmit}>
          <div className='row' style={{width:'50%'}}>
            <div className='col'>
              <TextFieldGroup
                onChange={this.onChange}
                value={firstName}
                type={'text'}
                field={'firstName'}
                label={'First Name'}
                placeholder={'First name of the user'}
                error={this.state.errors.firstName}/>
              <TextFieldGroup
                onChange={this.onChange}
                value={lastName}
                type={'text'}
                field={'lastName'}
                label={'Last Name'}
                placeholder={'Last name of the user'}
                error={this.state.errors.lastName}/>

              <TextFieldGroup
                onChange={this.onChange}
                value={email}
                type={'email'}
                field={'email'}
                label={'Email'}
                placeholder={'Email address of the user'}
                error={this.state.errors.email}/>
              <TextFieldGroup
                onChange={this.onChange}
                value={phone}
                type='number'
                field={'phone'}
                label={'Phone'}
                pattern={'[0-9]{10}'}
                placeholder={'03451234567'}
                error={this.state.errors.phone}/>

              {
                // this.state.groupDepthLevel !== 6 ?
                  <div className={classnames('form-group')}>
                      <SelectComponent
                        label='Select Group'
                        field='form-field-name'
                        placeholder='Select Group'
                        preSelected={this.state.selectedGroup}
                        optionKeys={{label: 'name', value: '_id'}}
                        options={this.props.groups}
                        error={this.state.errors.selectedGroup}
                        onChange={this.handleGroupChange}
                      />
                  </div> 
                  // : ''
              }

            </div>
           

          </div>
          <button className='btn auxo-primary-btn'>{this.state.loader ? [loader] : 'Create User'}</button>
        </form>
      </div>
      }</>
    );
  }
}

UserCreate.propTypes = {};
UserCreate.defaultProps = {};
const mapStateToProps = state => ({groups: state.groups.subGroups });
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Users.creators, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(UserCreate);
